export const OTP_DIAGNOSTIC_STATUS = Object.freeze({
  IDLE: "idle",
  PREVIEW_MOCK_ACTIVE: "preview_mock_active",
  ACTION_PREPARING: "action_preparing",
  PREVIEW_MOCK_READY: "preview_mock_ready",
  SCRIPT_LOADING: "script_loading",
  SCRIPT_LOADED: "script_loaded",
  INIT_INVOKED: "init_invoked",
  PROVIDER_CALLBACK_SUCCESS: "provider_callback_success",
  PROVIDER_CALLBACK_FAILURE: "provider_callback_failure",
  CALLBACK_TOKEN_MISSING: "callback_token_missing",
  ACCESS_TOKEN_HANDOFF: "access_token_handoff",
  BACKEND_VERIFIED: "backend_verified",
  PROVIDER_UNCONFIRMED: "provider_unconfirmed",
  BACKEND_REJECTED: "backend_rejected",
  INITIALIZATION_BLOCKED: "initialization_blocked",
  CALLBACK_TIMEOUT: "callback_timeout",
  INTEGRATION_ERROR: "integration_error",
});

const statusDetails = {
  [OTP_DIAGNOSTIC_STATUS.IDLE]: "Verification is ready.",
  [OTP_DIAGNOSTIC_STATUS.PREVIEW_MOCK_ACTIVE]:
    "Preview test mode is active. MSG91 is not contacted.",
  [OTP_DIAGNOSTIC_STATUS.ACTION_PREPARING]: "Preparing a secure verification session.",
  [OTP_DIAGNOSTIC_STATUS.PREVIEW_MOCK_READY]:
    "Preview test code is ready. No SMS was sent.",
  [OTP_DIAGNOSTIC_STATUS.SCRIPT_LOADING]: "Loading the secure verification service.",
  [OTP_DIAGNOSTIC_STATUS.SCRIPT_LOADED]: "Secure verification service loaded.",
  [OTP_DIAGNOSTIC_STATUS.INIT_INVOKED]:
    "MSG91 Default UI was invoked. Waiting for the provider response.",
  [OTP_DIAGNOSTIC_STATUS.PROVIDER_CALLBACK_SUCCESS]:
    "MSG91 reported a completed verification. Confirming it securely.",
  [OTP_DIAGNOSTIC_STATUS.PROVIDER_CALLBACK_FAILURE]:
    "MSG91 reported that verification could not continue.",
  [OTP_DIAGNOSTIC_STATUS.CALLBACK_TOKEN_MISSING]:
    "MSG91 completed verification, but no usable confirmation result was returned.",
  [OTP_DIAGNOSTIC_STATUS.ACCESS_TOKEN_HANDOFF]: "Confirming the provider result securely.",
  [OTP_DIAGNOSTIC_STATUS.BACKEND_VERIFIED]: "Verification confirmed by the secure service.",
  [OTP_DIAGNOSTIC_STATUS.PROVIDER_UNCONFIRMED]:
    "MSG91 verified your OTP. Independent server confirmation was unavailable, so it is recorded as pending. You can continue.",
  [OTP_DIAGNOSTIC_STATUS.BACKEND_REJECTED]:
    "The provider result could not be confirmed. Please try again.",
  [OTP_DIAGNOSTIC_STATUS.INITIALIZATION_BLOCKED]:
    "A secure verification request is already active.",
  [OTP_DIAGNOSTIC_STATUS.CALLBACK_TIMEOUT]:
    "Secure verification did not return a result. You can try again.",
  [OTP_DIAGNOSTIC_STATUS.INTEGRATION_ERROR]:
    "Secure verification could not be started. Please try again.",
};

const previewStatusDetails = {
  [OTP_DIAGNOSTIC_STATUS.BACKEND_VERIFIED]: "Preview verification confirmed.",
  [OTP_DIAGNOSTIC_STATUS.BACKEND_REJECTED]:
    "The preview verification code was not accepted. Please try again.",
};

const sdkEventStatus = {
  "script-inserted": OTP_DIAGNOSTIC_STATUS.SCRIPT_LOADING,
  "script-existing": OTP_DIAGNOSTIC_STATUS.SCRIPT_LOADING,
  "script-load-reused": OTP_DIAGNOSTIC_STATUS.SCRIPT_LOADING,
  "sdk-present": OTP_DIAGNOSTIC_STATUS.SCRIPT_LOADED,
  "script-loaded": OTP_DIAGNOSTIC_STATUS.SCRIPT_LOADED,
  "init-called": OTP_DIAGNOSTIC_STATUS.INIT_INVOKED,
  "success-callback": OTP_DIAGNOSTIC_STATUS.PROVIDER_CALLBACK_SUCCESS,
  "failure-callback": OTP_DIAGNOSTIC_STATUS.PROVIDER_CALLBACK_FAILURE,
  "init-already-active": OTP_DIAGNOSTIC_STATUS.INITIALIZATION_BLOCKED,
  "callback-timeout": OTP_DIAGNOSTIC_STATUS.CALLBACK_TIMEOUT,
  "script-error": OTP_DIAGNOSTIC_STATUS.INTEGRATION_ERROR,
  "script-timeout": OTP_DIAGNOSTIC_STATUS.INTEGRATION_ERROR,
  "sdk-api-missing": OTP_DIAGNOSTIC_STATUS.INTEGRATION_ERROR,
  "init-throw": OTP_DIAGNOSTIC_STATUS.INTEGRATION_ERROR,
};

export const getDiagnosticText = (status, mode) => {
  if (mode === "preview_mock" && previewStatusDetails[status]) {
    return previewStatusDetails[status];
  }
  return statusDetails[status] || statusDetails.idle;
};

export const statusForSdkEvent = (event) => sdkEventStatus[event] || null;

export const appendDiagnosticStatus = (history, status, maxEntries = 6) => {
  if (!status || history.at(-1) === status) return history;
  return [...history, status].slice(-maxEntries);
};